export async function initSlick() {
    if (wo$().slick) {
        return;
    }

    await import('./slick.nomodule');
}
